import { Col, Container, Row } from "react-bootstrap";
import Boton from "../Boton/Boton";
import Title from "../Title/Title";
import Social from "../Boton/Social";
import Seguinos from "../Seguinos/Seguinos";

const Main = ({ marca, listado, title }) => {
  return (
    <Container>
      <Row>
        <Col
          md={6}
          xs={12}
          className="mx-auto d-flex flex-column justify-content-center align-content-center align-items-center w-100"
        >
          {title ? <Title marca={marca} title={title} /> : <div className="pt-5" />}
          {listado
            .filter((e) => e.key === marca)[0]
            .botones.filter((e) => e.link !== null)
            .map((e) => (
              <Boton title={e.title} callback={e.link} icon={e.icon} style={marca} size={e.size} />
            ))}

          {marca === "usados" ? (
            <div className="boxSucursales w-100 ps-5 pe-5 pt-4">
              <p className={`subtitle ${marca} text-start`}>Sucursales</p>
              <ul className="list-unstyled">
                <li>
                  {" "}
                  <p className="mb-0 subtitleMap">Av. Monseñor Pablo Cabrera 4935, Córdoba, Capital</p>
                </li>
                <li className="pt-2">
                  <a
                    href="https://www.google.com/search?q=Montironi+Usados&stick=H4sIAAAAAAAA_-NgU1I1qLA0MTaytEwxSTI2MklNSrW0MqgwSk5NSjQ0MzRKszBONUtNXsQq4JufV5JZlJ-XqRBanJiSXwwAfwmR0DwAAAA&hl=es&mat=CROPjJgcCW5aElcBmzl_pTm-V3DEHwqih0ZaLBkBY1vtUDAED7_wu9ZSZpk7tQINf5yE1j_UoiaC3SY2fwI7AaPVHAeJTMyTuq-qs0Smq3Ipkf23XSFdHaGr7V-sMLvL87M&authuser=0"
                    target="_blank"
                    className="linkVerde"
                    rel="noreferrer"
                  >
                    Como llegar
                  </a>
                </li>

                <li className="pt-4">
                  <p className="mb-0 subtitleMap">La Cordillera 3697, Córdoba</p>
                </li>
                <li className="pt-2">
                  <a
                    href="https://www.google.com/search?q=Montironi+Usados&stick=H4sIAAAAAAAA_-NgU1IxqLA0MTaytDROskgxtjQwSEqyMqgwTTE2NrA0MUmzsEhJMTNfxCrgm59XklmUn5epEFqcmJJfDAAd_R4tOwAAAA&hl=es&mat=Cdm0J7hy8AzEElcBmzl_pfGfdwwUYT8BI12EQeT9iVnt0DhIxRmqHhNNkUpZyzk-_Z4nf9MwIdeXGV5oaIOFl0Z0LAnF6XESOqPHwT9Rj0ADKgJ9AZsFE8BQrioAFsmMOLk&authuser=0"
                    target="_blank"
                    className="linkVerde"
                    rel="noreferrer"
                  >
                    Como llegar
                  </a>
                </li>
              </ul>
            </div>
          ) : null}

          <Row>
            <Col className="mt-4 mb-3">
              <Seguinos marca={marca} title={"Seguinos en:"} />
              {listado
                .filter((e) => e.key === marca)[0]
                .social.map((e) => (
                  <Social icon={e.icon} callback={e.link} iconColor={e.color} style={marca} />
                ))}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Main;
